import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

const WarehouseIcon = ({ color, ...rest }: { color?: string; className?: string; [x: string]: unknown }) => {
  const { token } = useToken();
  return (
    <span role="img" aria-label="warehouse" className="anticon">
      <svg
        viewBox="0 0 18 19"
        focusable="false"
        width="1em"
        height="1em"
        fill="currentColor"
        aria-hidden="true"
        {...rest}
      >
        <path
          d="M16.875 13.3375H16.3125V4.47108L16.9924 4.32483C17.0662 4.31099 17.1365 4.28252 17.1991 4.24109C17.2617 4.19966 17.3154 4.14612 17.357 4.08361C17.3986 4.02111 17.4273 3.95091 17.4413 3.87715C17.4554 3.8034 17.4545 3.72758 17.4388 3.65416C17.423 3.58074 17.3928 3.51122 17.3498 3.44968C17.3067 3.38815 17.2518 3.33585 17.1883 3.29587C17.1247 3.25588 17.0538 3.22903 16.9797 3.21688C16.9056 3.20474 16.8299 3.20755 16.7569 3.22515L1.00687 6.60015C0.871189 6.62943 0.751121 6.70784 0.669765 6.82031C0.588409 6.93278 0.551512 7.07136 0.56617 7.20939C0.580829 7.34742 0.646007 7.47516 0.749169 7.56804C0.852331 7.66091 0.986191 7.71236 1.125 7.71249C1.16494 7.71242 1.20477 7.70818 1.24383 7.69983L1.6875 7.60491V13.3375H1.125C0.975816 13.3375 0.832742 13.3968 0.727252 13.5022C0.621763 13.6077 0.5625 13.7508 0.5625 13.9C0.5625 14.0492 0.621763 14.1922 0.727252 14.2977C0.832742 14.4032 0.975816 14.4625 1.125 14.4625H16.875C17.0242 14.4625 17.1673 14.4032 17.2727 14.2977C17.3782 14.1922 17.4375 14.0492 17.4375 13.9C17.4375 13.7508 17.3782 13.6077 17.2727 13.5022C17.1673 13.3968 17.0242 13.3375 16.875 13.3375ZM2.8125 7.36093L15.1875 4.71226V13.3375H13.5V9.39999C13.5 9.25081 13.4407 9.10773 13.3352 9.00224C13.2298 8.89675 13.0867 8.83749 12.9375 8.83749H5.0625C4.91332 8.83749 4.77024 8.89675 4.66475 9.00224C4.55926 9.10773 4.5 9.25081 4.5 9.39999V13.3375H2.8125V7.36093ZM12.375 11.0875H5.625V9.96249H12.375V11.0875ZM5.625 12.2125H12.375V13.3375H5.625V12.2125Z"
          fill={color ?? token.colorPrimary}
        />
      </svg>
    </span>
  );
};

export default WarehouseIcon;
